<template>
  <div>
    <img src="@/assets/img/lp/vitamind-plus-premium.jpg" />
  </div>
</template>


<style scoped>
</style>

<script>
</script>